import { Config } from 'config/envConfig';
import { isTruthy } from '@quyva/common';

export const getUrl = (fullUrl) => {
    const useFrontendBuild = isTruthy(Config.USE_FRONTEND_BUILD);
    if (useFrontendBuild) { 
        const url = new URL(fullUrl);
        return url.pathname + url.search + url.hash;
    } else {
        const useSecuredConnection = isTruthy(Config.USE_SECURED_CONNECTION);
        if (useSecuredConnection) {
            return fullUrl.replace('http:', 'https:');
        }
        return fullUrl;
    }
};

export const getFastApiUrl = (path) => {
    const normalizedPath = String(path || '').startsWith('/')
        ? String(path || '')
        : `/${String(path || '')}`;

    return getUrl(
        `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}${normalizedPath}`
    );
};
